import axios from 'axios';

export interface Job {
  jobId: string;
  name: string;
}

class JobsService {
  async getJobsByContactId(
    engageOrigin: string,
    accessToken: string,
    contactId: string
  ): Promise<Job[]> {
    try {
      const response = await axios.get(
        `${engageOrigin}/api/v1/contacts/${contactId}/jobs`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.data.success) return [];

      const jobs = response.data.data;

      return [...jobs];
    } catch (error) {
      return [];
    }
  }
}

export const jobsService = new JobsService();
